<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <form class="card" onSubmit="return false">
      <div class="card-body">
        <!-- general Info -->
        <div id="general-info" class="content">
          <div class="row g-6">
            <div class="col-12">
              <div class="d-flex align-items-start align-items-sm-center gap-6">
                <img
                  v-if="currentImageUrl"
                  :src="currentImageUrl"
                  alt="user-avatar"
                  class="d-block w-px-100 h-px-100 rounded"
                  id="uploadedAvatar"
                />
                <img
                  src="@/assets/img/avatars/1.png"
                  v-if="!currentImageUrl"
                  alt="user-avatar"
                  class="d-block w-px-100 h-px-100 rounded"
                  id="uploadedAvatar"
                />
                <div class="button-wrapper">
                  <label
                    for="upload_user"
                    class="btn btn-primary me-3 mb-4"
                    tabindex="0"
                  >
                    <span class="d-none d-sm-block">{{
                      $t("admins.upload_new_photo")
                    }}</span>
                    <i class="ti ti-upload d-block d-sm-none"></i>
                    <input
                      type="file"
                      class="account-file-input"
                      id="upload_user"
                      hidden
                      ref="imageFile"
                      @change="selectImage"
                      accept="image/png, image/jpeg"
                    />
                  </label>
                  <button
                    type="button"
                    class="btn btn-label-secondary account-image-reset mb-4"
                  >
                    <i class="ti ti-refresh-dot d-block d-sm-none"></i>
                    <span class="d-none d-sm-block">{{
                      $t("admins.reset")
                    }}</span>
                  </button>

                  <div>{{ $t("admins.allowed_jpg_png_max_2M") }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="">{{
                $t("admins.first_name")
              }}</label>
              <input
                type="text"
                v-model="admin.first_name"
                @input="validate"
                class="form-control"
                aria-describedby="basic-addon34"
                :placeholder="$t('admins.first_name')"
                :class="{ 'is-invalid': errors.first_name }"
              />
              <div v-if="errors.first_name" class="invalid-feedback">
                {{ errors.first_name }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="">{{
                $t("admins.last_name")
              }}</label>
              <input
                type="text"
                class="form-control"
                aria-describedby="basic-addon34"
                :placeholder="$t('admins.last_name')"
                v-model="admin.last_name"
                @input="validate"
                :class="{ 'is-invalid': errors.last_name }"
              />
              <div v-if="errors.last_name" class="invalid-feedback">
                {{ errors.last_name }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="">{{ $t("admins.email") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('admins.email')"
                v-model="admin.email"
                oninput="this.value=this.value.replace(/[^a-zA-Z0-9_.@-\s]/g,'');"
                @input="validate"
                :class="{ 'is-invalid': errors.email }"
              />
              <div v-if="errors.email" class="invalid-feedback">
                {{ errors.email }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="">{{ $t("admins.phone") }}</label>
              <div class="input-group input-group-merge">
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  class="form-control"
                  :placeholder="$t('admins.phone')"
                  v-model="admin.phone"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("admins.password")
              }}</label>
              <div class="input-group input-group-merge">
                <input
                  type="password"
                  class="form-control"
                  id="basic-default-password32"
                  :placeholder="admin.id ? 'No change' : '********'"
                  :class="{
                    'is-invalid': errors.password && !admin.id,
                  }"
                  v-model="admin.password"
                  aria-describedby="basic-default-password"
                />
                <div v-if="errors.password" class="invalid-feedback">
                  {{ errors.password }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Network Details -->
        <div id="profile-details" class="content">
          <div class="row g-6">
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("admins.custom_network_name")
              }}</label>
              <input
                type="text"
                v-model="admin.custom_network_name"
                class="form-control"
                id="basic-url3"
                aria-describedby="basic-addon34"
                :placeholder="
                  admin.custom_network_name ? '' : $t('control.default')
                "
              />
            </div>
            <div
              class="col-md-6"
              v-if="hasPrivilege('admins_custom_network_logo')"
            >
              <div
                class="d-flex align-items-start align-items-sm-center gap-6 mt-3 mb-3"
              >
                <img
                  v-if="currentLogoUrl"
                  :src="currentLogoUrl"
                  alt="user-avatar"
                  class="d-block w-px-100"
                  id="uploadedAvatar"
                />
                <div class="button-wrapper">
                  <label
                    for="upload_logo"
                    class="btn btn-primary btn-sm me-3 mb-2"
                    tabindex="0"
                  >
                    <span class="d-none d-sm-block">{{
                      $t("admins.upload_new_photo")
                    }}</span>
                    <i class="ti ti-upload d-block d-sm-none"></i>
                    <input
                      type="file"
                      id="upload_logo"
                      class="account-file-input"
                      ref="logoFile"
                      @change="selectLogo"
                      hidden
                      accept="image/png, image/jpeg"
                    />
                  </label>
                  <div>{{ $t("admins.custom_network_logo") }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="d-flex align-items-start align-items-sm-center gap-6 mt-3 mb-3"
              >
                <img
                  v-if="currentSignatureUrl"
                  :src="currentSignatureUrl"
                  alt="user-avatar"
                  class="d-block w-px-100"
                />
                <div class="button-wrapper">
                  <label
                    for="upload_sign"
                    class="btn btn-primary btn-sm me-3 mb-2"
                    tabindex="0"
                  >
                    <span class="d-none d-sm-block">{{
                      $t("admins.upload_new_photo")
                    }}</span>
                    <i class="ti ti-upload d-block d-sm-none"></i>
                    <input
                      type="file"
                      class="account-file-input"
                      ref="signatureFile"
                      @change="selectSignature"
                      id="upload_sign"
                      hidden
                      accept="image/png, image/jpeg"
                    />
                  </label>
                  <div>{{ $t("admins.signature") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Social Links -->
        <div id="other-info" class="content">
          <button
            class="btn btn-success"
            @click.prevent="store"
            :disabled="!validated"
          >
            {{ $t("admins.save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { hasPrivilege } from "../global_constants.js";
export default {
  name: "Personal",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      currentImageUrl: null,
      currentLogoUrl: null,
      currentSignatureUrl: null,
      loading: false,
      admin: {
        first_name: "",
        last_name: "",
        phone: "",
        profile_image: "",
        email: "",
        password: "",
        privileges: [],
        allowed_nases: [],
        allowed_profiles: [],
        type: "admin",
        money: "-1",
        prefix: "",
        custom_network_logo: "",
        custom_network_name: "",
        selected_privileges: [],
        signature: "",
        privileges_group_id: null,
      },
      privilege_groups: [],
      profiles: [],
      nases: [],
      privileges: [],
      options: [
        {
          id: 0,
          label: "All",
          isDefaultExpanded: true,
          children: null,
        },
      ],
      errors: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
      },
      validated: false,
      stepper: null,
      server_url: localStorage.getItem("server"),
    };
  },
  async created() {
    this.loading = true;
    await this.fetchAdmin();
    if (this.admin.profile_image) {
      this.currentImageUrl = this.server_url + this.admin.profile_image;
    }
    if (this.admin.custom_network_logo) {
      this.currentLogoUrl = this.server_url + this.admin.custom_network_logo;
    }
    if (this.admin.signature) {
      this.currentSignatureUrl = this.server_url + this.admin.signature;
    }
    this.validate();
  },
  methods: {
    nextStep() {
      this.stepper.next();
    },
    previousStep() {
      this.stepper.previous();
    },
    goStep(num) {
      this.stepper.to(num);
    },
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    selectImage() {
      this.admin.profile_image = this.$refs.imageFile.files.item(0);
      this.currentImageUrl = URL.createObjectURL(this.admin.profile_image);
    },
    selectLogo() {
      this.admin.custom_network_logo = this.$refs.logoFile.files.item(0);
      this.currentLogoUrl = URL.createObjectURL(this.admin.custom_network_logo);
    },
    selectSignature() {
      this.admin.signature = this.$refs.signatureFile.files.item(0);
      this.currentSignatureUrl = URL.createObjectURL(this.admin.signature);
    },
    async fetchAdmin() {
      this.loading = true;
      var adminId = this.user.id;
      const response = await axios.get(`admins/${adminId}`);
      if (response.status == 200) {
        this.admin = response.data.data;
      }
      this.loading = false;
    },
    checkAll(data, model) {
      if (!model.checkAll) {
        data.forEach((element) => {
          model.push(element);
        });
      } else {
        model.splice(0, model.length);
      }
    },
    async store() {
      try {
        this.loading = true;
        var data = new FormData();
        data.append("profile_image", this.admin.profile_image);
        data.append("custom_network_logo", this.admin.custom_network_logo);
        data.append("signature", this.admin.signature);
        data.append("first_name", this.admin.first_name);
        data.append("last_name", this.admin.last_name);
        data.append("phone", this.admin.phone);
        data.append("email", this.admin.email);
        data.append("password", this.admin.password);
        data.append("custom_network_name", this.admin.custom_network_name);
        var response = await axios.post(`/admins/${this.admin.id}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status == 200) {
          this.$notify({
            text: this.$t("messages.personal_details_updated_successfully"),
            type: "success",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("messages.personal_details_update_failed"),
          type: "error",
        });
        return;
      }
    },
    // async loadOptions({ action, parentNode, callback }) {
    //   this.loading = true;
    //   if (action === LOAD_CHILDREN_OPTIONS) {
    //     switch (parentNode.id) {
    //       case 0:
    //         const response = await axios.get("admins/privileges");
    //         parentNode.children = response.data;
    //         callback();
    //         break;
    //       default:
    //         break;
    //     }
    //   }
    //   this.loading = false;
    // },
    validate() {
      this.validated = true;
      this.errors.email = null;
      this.errors.password = null;
      this.errors.first_name = null;
      this.errors.last_name = null;
      if (this.admin.email.length < 3) {
        this.validated = false;
        this.errors.email = this.$t("errors.admins.username_3");
      }
      if (this.admin.first_name.length < 1) {
        this.validated = false;
        this.errors.first_name = this.$t("errors.admins.first_name");
      }
      if (this.admin.last_name.length < 1) {
        this.validated = false;
        this.errors.last_name = this.$t("errors.admins.last_name");
      }
      // if (!this.admin.password) this.admin.password = "1";
      // if (
      //   this.admin.password.length < 3 &&
      //   !this.admin.id &&
      //   !this.$route.params.id
      // ) {
      //   this.validated = false;
      //   this.errors.password = this.$t("errors.admins.password_3");
      // }
    },
    selectAll() {
      this.admin.privileges = [];
      this.privileges.forEach((element) => {
        element.children.forEach((privilege) => {
          this.admin.privileges.push(privilege.id);
        });
      });
    },
  },
};
</script>
